import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Col, FormGroup, Label, Button, Input } from 'reactstrap';
import { BASE_URL, API, ESTADOS_OPORTUNIDAD } from 'CONST';
import { patch, post } from 'helpers/requests';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CheckModal from '../shared/CheckModal';
import WarningModal from '../UI/WarningModal';
import AvanzarOportunidadConfirmationModal from './AvanzarOportunidadConfirmationModal';

const EmitirLineaSection = ({ fullData, id, estadosOportunidad, observaciones }) => {
  const history = useHistory();
  const [observacion, setObservacion] = useState('');
  const [observacionesEstado, setObservacionesEstado] = useState([]);
  const [editableSection, setEditableSection] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [confirmationGoodModal, setConfirmationGoodModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const editableStates = [ESTADOS_OPORTUNIDAD.contrafianzaCargada];

  useEffect(() => {
    if (observaciones) {
      setObservacionesEstado(
        observaciones.filter((obs) => obs.estado.nemotecnico === ESTADOS_OPORTUNIDAD.emitida),
      );
    }
    if (fullData && fullData.estado && editableStates.includes(fullData.estado.nemotecnico)) {
      setEditableSection(true);
    }
  }, [observaciones, fullData]);

  const postObservacion = () => {
    if (observacion) {
      const bodyObservacion = {
        oportunidad_id: id,
        estado_id: estadosOportunidad.find((e) => e.nemotecnico === ESTADOS_OPORTUNIDAD.emitida).id,
        observacion,
      };
      post(`${BASE_URL}${API.observacionesOportunidad}`, bodyObservacion)
        .then(() => {
          setShowUpdateModal(true);
        })
        .catch(() => {
          setShowErrorModal(true);
        });
    }
  };

  const emitirOportunidad = () => {
    setLoading(true);
    const body = {
      estado_id: estadosOportunidad.find((e) => e.nemotecnico === ESTADOS_OPORTUNIDAD.emitida).id,
    };
    post(`${BASE_URL}${API.oportunidadesLinea}${id}/emitir/`) // TODO: Ver ruta
      .then(() => {
        patch(`${BASE_URL}${API.oportunidadesLinea}${id}/`, body)
          .then(() => {
            postObservacion();
            setShowUpdateModal(true);
          })
          .catch(() => {
            setShowErrorModal(true);
          });
      })
      .catch(() => {
        setShowErrorModal(true);
      })
      .finally(() => {
        setConfirmationGoodModal(false);
        setLoading(false);
      });
  };

  return (
    <div>
      <FormGroup row>
        <Col sm={2}>
          <Label>Observaciones</Label>
        </Col>
        <Col>
          <Input
            id="observacion-info-inicial"
            type="textarea"
            value={
              !editableSection && observacionesEstado.length > 0
                ? observacionesEstado[0].observacion
                : observacion || ''
            }
            onChange={(event) => setObservacion(event.target.value)}
            rows="3"
            disabled={!editableSection}
          />
        </Col>
      </FormGroup>
      {observacionesEstado.slice(!editableSection).map((obs) => {
        return (
          <FormGroup row key={obs.id}>
            <Col sm={2} />
            <Col>
              <Input type="textarea" value={obs.observacion} rows="3" disabled />
            </Col>
          </FormGroup>
        );
      })}
      {editableSection && (
        <div className="button-container d-flex justify-content-end">
          <Button
            className="btn btn-secondary blue"
            onClick={() => setConfirmationGoodModal(true)}
            disabled={loading}
          >
            {loading ? <FontAwesomeIcon spin={loading} icon={faSpinner} /> : 'Emitir línea'}
          </Button>
        </div>
      )}
      <CheckModal
        isOpen={showUpdateModal}
        toggle={() => history.push('/garantia/oportunidades')}
        handleOk={() => history.push('/garantia/oportunidades')}
        okBtnText="OK"
        confirmMsg="Oportunidad emitida exitosamente."
      />
      <AvanzarOportunidadConfirmationModal
        openModal={confirmationGoodModal}
        setOpenModal={setConfirmationGoodModal}
        avanzarOportunidad={emitirOportunidad}
        loading={loading}
        mensajeModal="¿Está seguro que desea EMITIR esta oportunidad?"
      />
      <WarningModal
        isOpen={showErrorModal}
        toggle={() => setShowErrorModal(false)}
        handleOk={() => setShowErrorModal(false)}
        okBtnText="Aceptar"
        confirmMsg="Ha ocurrido un error al emitir la oportunidad."
        loading={false}
        onlyCancelButton
      />
    </div>
  );
};

EmitirLineaSection.propTypes = {
  id: PropTypes.string,
  fullData: PropTypes.shape({
    afianzado: PropTypes.shape({
      id: PropTypes.number,
    }),
    estado: PropTypes.shape({
      id: PropTypes.number,
      nemotecnico: PropTypes.string,
    }),
    id: PropTypes.number,
    monto: PropTypes.number,
    exposicion_maxima: PropTypes.number,
  }),
  estadosOportunidad: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      nemotecnico: PropTypes.string,
    }),
  ),
  observaciones: PropTypes.arrayOf(
    PropTypes.shape({
      estado: PropTypes.shape({
        id: PropTypes.number,
        nemotecnico: PropTypes.string,
      }),
      id: PropTypes.number,
    }),
  ),
};

EmitirLineaSection.defaultProps = {
  fullData: null,
  id: null,
  estadosOportunidad: [],
  observaciones: [],
};

export default EmitirLineaSection;
